/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { IComponentProps } from '@msdyn365-commerce/core';
import { SimpleProduct } from '@msdyn365-commerce/retail-proxy';
import * as React from 'react';
import { Modal, ModalHeader } from '@msdyn365-commerce-modules/utilities';

export interface IPopupProps extends IComponentProps<{ product: SimpleProduct | undefined; }> {
    dialogStrings?: {
        message: string;
        buttonMessage: string;
    };
    className: string;
    navigationUrl?: string;
    modalOpen: boolean | undefined;
    setModalOpen(newValue: boolean): void;
}

export const Popup = (popupProps: IPopupProps) => {
    const {
        dialogStrings,
        className,
        navigationUrl,
        modalOpen,
        setModalOpen,
    } = popupProps;
    const closeModal = React.useCallback(() => {
        window.location.assign(navigationUrl!);
        setModalOpen(false);
    }, [setModalOpen]);
    if (!dialogStrings) {
        return null;
    }

    return (
        <Modal isOpen={modalOpen} onClosed={closeModal} className={`${className}__dialog`} toggle={closeModal}>
            <ModalHeader toggle={closeModal} className={`${className}__dialog__header`}>
                <span id='hso-redirect-message'>{dialogStrings.message}</span>
            </ModalHeader>
        </Modal>
    );
};

export default Popup;
